import { useState } from "react";
import axios from "axios";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { SITE } from "@/constants/testIds";
import { ContactFields, emptyContact } from "./ContactFields";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ids = {
  name: SITE.reqName, email: SITE.reqEmail, phone: SITE.reqPhone,
  area: SITE.reqArea, message: SITE.reqMessage, privacy: SITE.reqPrivacy,
};

export const RequestForm = () => {
  const [form, setForm] = useState(emptyContact);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.privacy) return toast.error("È necessario accettare l'informativa privacy.");
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/requests`, form);
      setDone(data);
      toast.success("Richiesta inviata con successo.");
    } catch (err) {
      toast.error("Invio non riuscito. Riprova o chiama lo studio.");
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div data-testid={SITE.reqSuccess} className="py-16 text-center">
        <CheckCircle2 className="mx-auto h-12 w-12 text-bronze" strokeWidth={1.4} />
        <h3 className="mt-6 text-2xl font-semibold text-navy-900">Grazie, {done.name}.</h3>
        <p className="mt-3 text-navy-500">La tua richiesta è stata ricevuta. Lo studio ti ricontatterà al più presto.</p>
        <Button variant="outline" onClick={() => { setDone(null); setForm(emptyContact); }} className="mt-8 rounded-full border-navy-900 text-navy-900">
          Invia un'altra richiesta
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="max-w-3xl">
      <p className="mb-8 text-navy-500">Descrivi in poche righe la tua situazione: lo studio ti ricontatterà per fissare una consulenza.</p>
      <ContactFields value={form} onChange={setForm} ids={ids} messageRequired />
      <Button type="submit" disabled={sending} data-testid={SITE.reqSubmit} className="mt-8 w-full sm:w-auto rounded-full bg-navy-900 hover:bg-navy-700 h-14 px-8 font-semibold tracking-wide transition-colors">
        {sending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Invia la richiesta
      </Button>
    </form>
  );
};
